import { Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import * as React from "react";
import { Button, useRefresh } from "react-admin";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSubmit from "../../unit/CustomButtonSubmit";
import CustomDateTextInput from "../../unit/CustomDateTextInput";
import CustomDialogTitle from "../../unit/CustomDialogTitle";
import HeaderLabelTitle from "../../unit/HeaderLabelTitle";
import UploadSingleFile from "../../unit/UploadSingleFile";
import useNotify from "../../unit/useNotify";
import DialogApplicationBaseInfo from "../DialogApplicationBaseInfo";
import CustomApplicationDialogTitle from "./CustomApplicationDialogTitle";
import { error } from "console";

export default function CustomExpired2OfflineDialog({ ...props }) {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const { appId, record } = props;
  const [open, setOpen] = React.useState(false);
  const [dateClosing, setdateClosing] = React.useState("");
  const refresh = useRefresh();
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    refresh();
  };

  return (
    <React.Fragment>
      <Button
        id="btn-application-expired-offline"
        label="Offline"
        variant="contained"
        size="medium"
        color="primary"
        sx={{
          marginLeft: "10px",
          width: "120px",
          "&:hover": { bgcolor: "gray" },
        }}
        onClick={handleClickOpen}
      />
      <Dialog
        id="dialog-application-expired-offline"
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="md"
        PaperProps={{
          component: "form",
          onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            const reqUrl = `applications/actions/expired/toApproved`;
            const formData = new FormData(event.currentTarget);
            // var uploadFileId = document.getElementById("uploadFileId") as any;
            //uploadFileId is input name
            var uploadFileId = document.querySelector(
              'input[name="uploadFileId"]'
            ) as any;
            if (uploadFileId) {
              formData.append("uploadFileIds", uploadFileId.value);
            } else {
              errorNotify("Please upload the closing document to proceed.");
              return false;
            }
            const formJson = Object.fromEntries((formData as any).entries());
            formJson.action = "complete";
            const response = await sendRequest(reqUrl, {
              id: appId,
              data: formJson,
            });
            if (
              response &&
              (response.status == "200" || response.code == "200")
            ) {
              successNotify("Data saved successfully");
              if (props?.cb) {
                props.cb("Approved");
              }
              handleClose();
            } else {
              errorNotify(response?.message || "Data not saved!");
            }
          },
        }}
      >
        <DialogTitle
          sx={{
            borderBottom: "1px solid #e5e5e5",
            mb: 2,
          }}
        >
          <CustomApplicationDialogTitle record={record} subTitle="Offline" />
        </DialogTitle>
        <DialogContent>
          <DialogApplicationBaseInfo appId={appId} record={record} />
          <DialogContentText>
            <Grid sx={{ mb: 2 }} container>
              <Grid item xs={5} sx={{ pt: 1 }}>
                <HeaderLabelTitle title="Date of Closing" />
              </Grid>
              <Grid item xs={5}>
                <CustomDateTextInput
                  id="date_of_closing"
                  name="date_of_closing"
                  value="today"
                  required={true}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    if (e.target.value != "") {
                      setdateClosing(e.target.value);
                    }
                  }}
                />
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>
            <Grid sx={{ mb: 2 }} container>
              <Grid item xs={5} sx={{ pt: 1 }}>
                <HeaderLabelTitle title="Please upload Closing Document (Only PDF files)" />
              </Grid>
              <Grid item xs={5}>
                <UploadSingleFile
                  appId={appId}
                  uploadFieldId="appachment_upload"
                  useUploadFileName={true}
                  fixedUploadName="offline closing document"
                  uploadType="offline_closing"
                  uploadStep="Expired"
                  requiredFileType={["pdf"]}
                />
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>

            <Typography variant="body2" sx={{ color: "red" }}>
              Click on "Submit" button below to confirm Application
              {appId} is ready for execution. This application will then be
              moved to "Approved" page in the Applications drop down menu.
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomButtonCancel onClick={handleClose} />
          <CustomButtonSubmit />
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
